var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"flex-center text-sm rounded-full shrink-0 w-6 h-6 hover:bg-gray-200 dark:hover:bg-gray-800",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', $event)}}},[_c('SaIcon',{attrs:{"name":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }